import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './photog_v2/Header';
import Footer from './photog_v2/Footer';
import Home from './photog_v2/Home';
import Archive from './photog_v2/Archive';
import Note from './photog_v2/Note';
import Commission from './photog_v2/Commission';

export default function PhotographerTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="mh-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`mh-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'archive' && <Archive setPage={setPage} />}
          {page === 'note' && <Note setPage={setPage} />}
          {page === 'commission' && <Commission setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
